import { handleActions } from 'redux-actions';

import * as types from './actionTypes';
import { getNewRole } from './utils';

export const initialState = {
	userLogon: '',
	firstName: '',
	surname: '',
	userFullName: '',
	currentRole: '',
	allowedCompanies: [],
	roleStructureMap: [],
	permissions: [],
	hasSubordinates: false,
};

const reducerMap = {
	[types.SET_ADDITIONAL_USER_INFO]: (state, { payload }) => {
		return {
			...state,
			...payload,
			userFetched: true,
			currentRole: getNewRole(state.currentRole, payload.roleStructureMap || {}),
			isEDKSubSeller: payload.isEDKSubSeller || false,
		};
	},
	[types.SET_ROLE]: (state, { payload }) => {
		return {
			...state,
			currentRole: payload.role,
		};
	},
};

export default handleActions(reducerMap, initialState);
